var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('centered-card',{attrs:{"headline":"Your Account was deleted"}},[_c('h3',[_vm._v("Thanks for using pimblr!")]),_vm._v(" "),_c('p',[_vm._v("We hope, you enjoyed your stay and we will be very happy if you will return anytime.")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bb86dda0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/AccountDeletedPage.vue
// module id = Irel
// module chunks = 0